import type { IFieldElem } from '@models/IFormData';

/**
 * Поле `variables` вложенной формы (форма строки, подформа), которое читает переменные карточки
 * в момент вычисления. Карточка пересчитывает их (смена режима, обновление документа), а открытая
 * форма не переинициализируется — это стёрло бы ввод. Формулы читают `.value` при каждом вычислении.
 */
export const liveVariablesField = (getVariables: () => IFieldElem | undefined): IFieldElem => ({
    name: 'variables',
    index: -1,
    get value() {
        return getVariables()?.value;
    },
});
